import { CompanyListPage } from "@/pages/company-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/admin/companies/")({
  component: () => <CompanyListPage />,
});
